import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["entity"],
    _excluded2 = ["text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ButtonLink } from '../../elements/button-link';
import ModuleWrapper from '../../helpers/module-wrapper';
import { useEntity } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var ConnectedButton = function ConnectedButton(_ref) {
  var entity = _ref.entity,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useEntity = useEntity(entity),
      text = _useEntity.text,
      props = _objectWithoutProperties(_useEntity, _excluded2);

  return _jsx(ButtonLink, _objectSpread(_objectSpread(_objectSpread({}, rest), props), {}, {
    children: text
  }));
};

export default (function (_ref2) {
  var _ref2$entries = _ref2.entries,
      entries = _ref2$entries === void 0 ? [] : _ref2$entries,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {} : _ref2$options;
  var _options$spacingTop = options.spacingTop,
      spacingTop = _options$spacingTop === void 0 ? 'lg' : _options$spacingTop,
      _options$spacingBotto = options.spacingBottom,
      spacingBottom = _options$spacingBotto === void 0 ? 'lg' : _options$spacingBotto; // TODO: check if moduleWrapper is needed

  return _jsx("div", {
    sx: {
      textAlign: ['left', 'right']
    },
    children: _jsx(ModuleWrapper, {
      spacingTop: spacingTop,
      spacingBottom: spacingBottom,
      children: _jsx("div", {
        sx: function sx(theme) {
          return {
            display: ['block', 'inline-flex'],
            flexDirection: 'row-reverse',
            marginLeft: -theme.space.sm,
            marginBottom: -theme.space.sm
          };
        },
        children: entries.map(function (entry, key) {
          return _jsx(ConnectedButton, {
            entity: entry,
            sx: {
              marginBottom: 'sm',
              marginLeft: 'sm'
            }
          }, key);
        }, this)
      })
    })
  });
});
//# sourceMappingURL=collection-buttons.js.map